<template>
  <div class="anomaly-subscription pa-10">

    <title-page icon="mdi-file-document-alert-outline">
      {{ $t('anomaly.subscription-anomalies') }}
    </title-page>

    <v-progress-linear v-if="loading" indeterminate color="primary" class="mb-4" />

    <subscription-anomaly-list ref="anomalyList" @loading="loading = $event" />

  </div>
</template>

<script>
import SubscriptionAnomalyList from "@elements/SubscriptionAnomalyList.vue";

export default {
  components: { SubscriptionAnomalyList },

  data() {
    return {
      loading: false,
    }
  },
}
</script>

<style lang="scss">
.anomaly-subscription {
  min-height: 1000px;
}
</style>
